import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Section, SectionConfig, TemplateConfig, } from '../dto/response/template.config';
import { TemplateStatus } from '../dto/request/template-config.request';

@Injectable({
  providedIn: 'root',
})
export class TemplateConfigService {
  constructor(private http: HttpClient) { }



  getTemplateConfig(): Observable<TemplateConfig> {


    return this.http
      .get<TemplateConfig>(`${environment.baseURL}${environment.SITE_CONFIG}`)
      .pipe(finalize(() => { }));
  }

  findSectionById(sections: Section[], sectionId: string): Section | undefined {
    return sections.find((section) => section.section_id === sectionId);
  }

  findConfig(config: SectionConfig | undefined, propertyKey: string): any {
    return config ? config[propertyKey] : undefined;
  }
}
